const WithdrawReason = {
  BACKUP: 'backup',
  PROFIT_AND_LOSS: 'profitAndLoss',
  OTHER: 'other',
};

module.exports = WithdrawReason;
